export function checkIfInIframe() {
  return window.self !== window.top;
}
